<template>
  <m-base :showTopBorder="pattern.showTopBorder" :showBottomBorder="pattern.showBottomBorder">
    <div slot="box" class="car-section">
      <!-- 背景色区域 -->
      <div class="titleNdiv-background">
        <div
          class="titleNdiv-image"
          :style="{backgroundImage:'url('+(data.length>0?data[swiperIndex].src:'')+')'}"
        ></div>
      </div>
      <!-- 标题栏和状态栏占位符 -->
      <div class="titleNdiv-placing">
        <div class="mp-search-box" @click="navToSearchPage">
          <input class="ser-input" type="text" :placeholder="params.placeholder" disabled />
        </div>
      </div>
      <van-swipe
        width="100%"
        height="175"
        :autoplay="6000"
        :show-indicators="false"
        @change="swiperChange"
      >
        <van-swipe-item
          v-for="(item, index) in data"
          :key="index"
          class="car-item"
          @click="navToDetailPage(item,index)"
        >
          <van-image lazy-load class="car-item-image" :src="item.src" />
        </van-swipe-item>
        <template #indicator>
          <div v-if="pattern.dotType == 2" class="swiper-dots2">
            <div
              v-for="(item, index) in data"
              :key="index"
              class="block"
              :class="{current:swiperIndex == index}"
            />
          </div>
          <div v-if="pattern.dotType == 3" class="swiper-dots3">
            <div
              v-for="(item, index) in data"
              :key="index"
              class="block"
              :class="{current:swiperIndex == index}"
            />
          </div>
          <div v-if="pattern.dotType == 1" class="swiper-dots1">
            <span class="num">{{swiperIndex+1}}</span>
            <span class="sign">/</span>
            <span class="num">{{data.length}}</span>
          </div>
        </template>
      </van-swipe>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          placeholder: '请输入关键字搜索',
        }
      }
    },
    data: {
      type: Array,
      default: () => [{
        src: require("@/static/temp/banner3.jpg"),
        navTo: ''
      }, {
        src: require("@/static/temp/banner2.jpg"),
        navTo: ''
      }, {
        src: require("@/static/temp/banner4.jpg"),
        navTo: ''
      }]
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showBottomBorder: true,
          dotType: 1
        }
      }
    },
  },
  data () {
    return {
      swiperIndex: 0,
    };
  },
  methods: {
    swiperChange (index) {
      this.swiperIndex = index;
    },
    navToSearchPage () {
      this.$router.push('/pages/search/search')
    },
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          let location = this.$uitl.getPathQuery(navTo)
          this.$router.push(location)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.car-section {
  position: relative;
}

//搜索栏
.titleNdiv-placing {
  height: 50px;
  box-sizing: content-box;

  .mp-search-box {
    position: relative;
    display: flex;
    width: 100%;
    padding: 12px 20px 7px 20px;

    .ser-input {
      flex: 1;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      color: $font-color-base;
      border-radius: 15px;
      background: rgba(255, 255, 255, 0.6);
    }
  }
}

//背景图
.titleNdiv-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 215px;
  overflow: hidden;

  .titleNdiv-image {
    width: 100%;
    height: 100%;
    transition: 0.4s;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(5px);
  }
}

//轮播图
.car-item {
  padding: 5px 14px 5px 14px;
  overflow: hidden;
}

.car-item-image {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

//指示器
.swiper-dots1 {
  display: flex;
  position: absolute;
  left: 30px;
  bottom: 10px;
  width: 36px;
  height: 18px;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
  .num {
    width: 18px;
    height: 18px;
    border-radius: 50px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 18px;
  }

  .sign {
    position: absolute;
    top: 0;
    left: 50%;
    line-height: 18px;
    font-size: 6px;
    color: #fff;
    transform: translateX(-50%);
  }
}

.swiper-dots2 {
  display: flex;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .block {
    width: 6px;
    height: 6px;
    border-radius: 4px;
    background-color: white;
    margin: 0 2px;
    transition: all 0.5s;
  }
  .current {
    width: 12px;
    background-color: red;
  }
}

.swiper-dots3 {
  display: flex;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .block {
    width: 12px;
    height: 3px;
    background-color: white;
    margin: 0 2px;
    transition: all 0.5s;
  }
  .current {
    background-color: rgb(53, 96, 220);
  }
}
</style>
